import { render, staticRenderFns } from "./TestPackageGroupDetail.vue?vue&type=template&id=235fa2dd"
import script from "./TestPackageGroupDetail.vue?vue&type=script&lang=js"
export * from "./TestPackageGroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports